/**
 * Render a transcript for a talkthrough scratchpad.
 */
import * as React from "react";

type Props = {
    // Fires during a seek
    onSeek: (timeInSeconds: number) => unknown;
    // When the seeking ends
    onSeekEnd: () => unknown;
    // When the seeking begins
    onSeekStart: () => unknown;
    // Listen for when updates to the play state occur (such as
    // the current playback time changing)
    registerPlayUpdate: (arg1: (timeInSeconds: number) => unknown) => unknown;
    // A transcript model to render
    // NOTE(jeresig): We don't check that it's actually a Backbone
    // model as it would require that we load the Transcript model
    // synchronously, and we want it to load async.
    transcript: any;
};

class ScratchpadTranscript extends React.Component<Props> {
    componentDidMount() {
        this.loadInteractiveTranscript();
    }

    loadInteractiveTranscript: () => void = () => {
        Promise.all([
            import("../transcripts-package/transcripts.ts"),
            import("../../stylesheets/video-package/video.less"),
            // @ts-expect-error - TS2345 - Argument of type '([{ InteractiveTranscriptView }]: [any]) => void' is not assignable to parameter of type '(value: [typeof import("/Users/kevinbarabash/khan/webapp/apps/khanacademy/src/transcripts-package/transcripts"), any]) => void | PromiseLike<void>'.
        ]).then(([{InteractiveTranscriptView}]: [any]) => {
            const transcriptView = new InteractiveTranscriptView({
                model: this.props.transcript,
            });

            transcriptView.on("subtitleSelection", (timeSeconds) => {
                this.props.onSeekStart();
                this.props.onSeek(timeSeconds * 1000);
                this.props.onSeekEnd();
            });

            this.props.registerPlayUpdate((time: number) =>
                transcriptView.onPlayerUpdate(time),
            );

            // @ts-expect-error - TS2339 - Property 'appendChild' does not exist on type 'ReactInstance'.
            // eslint-disable-next-line react/no-string-refs
            this.refs.transcript.appendChild(transcriptView.render().el);

            // Force the transcript to display
            transcriptView.showWithSlide();
        });
    };

    render(): React.ReactNode {
        // eslint-disable-next-line react/no-string-refs
        return <div ref="transcript" />;
    }
}

export default ScratchpadTranscript;
